import * as Sentry from "@sentry/react";
import axios from "axios";

import { Pagination } from "./requestWithToken";

export type BaseResponse<T> = {
  data: T;
  pagination: T extends unknown[] ? Pagination : undefined;
};

type Response<T, K = unknown> = K extends object ? BaseResponse<T> & K : BaseResponse<T>;

function request<Data, Meta>(
  url: string,
  httpMethod: "GET" | "POST" | "PATCH" | "DELETE" | "PUT",
  token?: string,
  data?: object,
  params?: object,
  customHeaders?: object
): Promise<Response<Data, Meta>> {
  return axios
    .request({
      method: httpMethod,
      url,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...customHeaders,
      },
      data,
      params,
    })
    .then((res) => res.data)
    .catch((err) => {
      let errorMessage = err;

      if (err?.response) {
        const statusCode = err?.response?.status;
        const statusPrefix = Math.floor(statusCode / 100); // Get the first digit (e.g., 4 for 4xx)

        switch (statusPrefix) {
          case 5:
            errorMessage = {
              message:
                "We're unable to process your request at this time due to temporary technical issues. Please try again later or contact Customer Support if the problem persists.",
            };
            break;
        }
      }

      Sentry.captureException(errorMessage);
      throw errorMessage;
    });
}

export default request;
